// Copyright (c) 2016 Deere & Company

import ClaimsSettings, {getDefaultState as getClaimsSettingsDefaultState} from './claims-settings';
import DbsSettings, {getDefaultState as getDbsSettingsDefaultState} from './dbs-settings';
import DealerSettings, {getDefaultState as getDealerSettingsDefaultState} from './dealer-settings';
import GeneralSettings, {getDefaultState as getGeneralSettingsDefaultState} from './general-settings';
import LanguageSettings, {getDefaultState as getLanguageSettingsDefaultState} from './language-settings';
import PartReturnSettings, {getDefaultState as getPartReturnSettingsDefaultState} from './part-return-settings';
import ReimbursementSummarySettings, {getDefaultState as getReimbursementSummarySettingsDefaultState} from './reimbursement-summary-settings';
import ThemeSettings, {getDefaultState as getThemeSettingsDefaultState} from './theme-settings';

import t from 'tcomb';

const UserSettings = t.struct({
    claims: ClaimsSettings,
    dbs: DbsSettings,
    dealer: DealerSettings,
    general: GeneralSettings,
    language: LanguageSettings,
    partReturns: PartReturnSettings,
    reimbursementSummary: ReimbursementSummarySettings,
    theme: ThemeSettings
}, {
    name: 'UserSettings',
    strict: true
});

export const getDefaultState = () => new UserSettings({
    claims: getClaimsSettingsDefaultState(),
    dbs: getDbsSettingsDefaultState(),
    dealer: getDealerSettingsDefaultState(),
    general: getGeneralSettingsDefaultState(),
    language: getLanguageSettingsDefaultState(),
    partReturns: getPartReturnSettingsDefaultState(),
    reimbursementSummary: getReimbursementSummarySettingsDefaultState(),
    theme: getThemeSettingsDefaultState()
});

export default UserSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/user-settings.js